import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Manages ActionCable subscription for real-time menu badge updates
// Subscribes on connect, unsubscribes on disconnect (Turbo-safe)
export default class extends Controller {
  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        received: (message) => this.handleMessage(message)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  handleMessage(message) {
    if (message.type === "menu_badge") {
      this.updateMenuBadge(message.data)
    }
  }

  updateMenuBadge(data) {
    let badgeElement = document.querySelector(`[data-menu-badge="${data.badge}"]`)
    this.updatePrimaryBadge(data, badgeElement)

    // The collapsed strip's flyouts (shared/menu/_flyout) carry a copy of each
    // count; they follow the rail's own badge, text and hidden alike.
    const primary = document.querySelector(`[data-menu-badge="${data.badge}"]`)
    if (!primary) return
    document.querySelectorAll(`[data-menu-badge="${data.badge}"]`).forEach((copy) => {
      if (copy === primary) return
      copy.textContent = primary.textContent
      copy.classList.toggle("hidden", primary.classList.contains("hidden"))
    })
  }

  updatePrimaryBadge(data, badgeElement) {

    if (data.count > 0) {
      // If badge doesn't exist and we have a count > 0, create it
      if (!badgeElement) {
        // Find the menu link for this badge (e.g., the link containing "Keys")
        const menuLink = document.querySelector(`aside a[href*="/${data.badge}"]`)
        if (menuLink) {
          // For subitems, ensure the flex layout is set up for badges
          if (menuLink.classList.contains("menu-dropdown-item") &&
              !menuLink.classList.contains("justify-between")) {
            menuLink.classList.add("justify-between")
          }

          // Create the badge element
          badgeElement = document.createElement("span")

          // Determine badge style (success, warning, danger, or default)
          const badgeStyle = data.style || "default"
          const isSuccess = badgeStyle === "success"
          const isWarning = badgeStyle === "warning"
          const isDanger = badgeStyle === "danger"

          // Set base badge class based on style
          if (isSuccess) {
            badgeElement.className = "menu-item-badge-success"
          } else if (isDanger) {
            badgeElement.className = "menu-item-badge-danger"
          } else if (isWarning) {
            badgeElement.className = "menu-item-badge-warning"
          } else {
            badgeElement.className = "menu-item-badge"
          }
          badgeElement.setAttribute("data-menu-badge", data.badge)

          // Check if this is an active menu item to set correct styling
          const isActive = menuLink.classList.contains("menu-item-active")

          // Add active/inactive class based on style
          if (isSuccess) {
            badgeElement.classList.add(isActive ? "menu-item-badge-success-active" : "menu-item-badge-success-inactive")
          } else if (isDanger) {
            badgeElement.classList.add(isActive ? "menu-item-badge-danger-active" : "menu-item-badge-danger-inactive")
          } else if (isWarning) {
            badgeElement.classList.add(isActive ? "menu-item-badge-warning-active" : "menu-item-badge-warning-inactive")
          } else {
            badgeElement.classList.add(isActive ? "menu-item-badge-active" : "menu-item-badge-inactive")
          }

          // Insert the badge
          menuLink.appendChild(badgeElement)
        }
      }

      if (badgeElement) {
        // Format badge text based on badge type
        const badgeText = data.text || `${data.count} out`
        badgeElement.textContent = badgeText
        badgeElement.classList.remove("hidden")

        // Update badge style if it changed (e.g., from warning to danger)
        const badgeStyle = data.style || "default"
        const menuLink = badgeElement.closest("a")
        const isActive = menuLink?.classList.contains("menu-item-active") || false

        // Remove old style classes and add new ones
        badgeElement.classList.remove(
          "menu-item-badge", "menu-item-badge-success", "menu-item-badge-warning", "menu-item-badge-danger",
          "menu-item-badge-active", "menu-item-badge-inactive",
          "menu-item-badge-success-active", "menu-item-badge-success-inactive",
          "menu-item-badge-warning-active", "menu-item-badge-warning-inactive",
          "menu-item-badge-danger-active", "menu-item-badge-danger-inactive"
        )

        if (badgeStyle === "success") {
          badgeElement.classList.add("menu-item-badge-success", isActive ? "menu-item-badge-success-active" : "menu-item-badge-success-inactive")
        } else if (badgeStyle === "danger") {
          badgeElement.classList.add("menu-item-badge-danger", isActive ? "menu-item-badge-danger-active" : "menu-item-badge-danger-inactive")
        } else if (badgeStyle === "warning") {
          badgeElement.classList.add("menu-item-badge-warning", isActive ? "menu-item-badge-warning-active" : "menu-item-badge-warning-inactive")
        } else {
          badgeElement.classList.add("menu-item-badge", isActive ? "menu-item-badge-active" : "menu-item-badge-inactive")
        }
      }
    } else {
      // If count is 0 and badge exists, hide it
      if (badgeElement) {
        badgeElement.classList.add("hidden")
      }
    }
  }
}
